import Vue from 'vue';
import Vuetify from 'vuetify';
import jQuery from 'jquery';
import Bloodhound from 'bloodhound-js';
import UtilitiesService from './services/UtilitiesService';
import AxiosService from './services/AxiosService';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import 'typeahead.js';

UtilitiesService.registerGlobal(jQuery, ['jQuery', '$']);
UtilitiesService.registerGlobal(Bloodhound, 'Bloodhound');
UtilitiesService.registerGlobal(process.env.NODE_ENV, 'NODE_ENV');

AxiosService.bindGlobal();

Vue.use(Vuetify, { theme: false });

Vue.component('mimity-layout'    , () => import('@/views/MimityLayout.vue'                ));
Vue.component('admin-layout'     , () => import('@/views/AdminLayout.vue'                 ));

Vue.component('menu-header'      , () => import('@/components/Mimity/menu-header.vue'     ));
Vue.component('page-footer'      , () => import('@/components/Mimity/page-footer.vue'     ));
Vue.component('scroll-top-btn'   , () => import('@/components/Mimity/scroll-top-btn.vue'  ));
Vue.component('menu-modal'       , () => import('@/components/Mimity/menu-modal.vue'      ));
Vue.component('login-modal'      , () => import('@/components/Mimity/login-modal.vue'     ));
Vue.component('image-slider'     , () => import('@/components/Mimity/ImageSlider.vue'     ));
Vue.component('slogan'           , () => import('@/components/Mimity/slogan.vue'          ));
Vue.component('product'          , () => import('@/components/Mimity/Product.vue'         ));
Vue.component('featured-product' , () => import('@/components/Mimity/FeaturedProduct.vue' ));

Vue.component('translation-editor', () => import('@/components/Admin/TranslationEditor.vue'));
Vue.component('translation-box'   , () => import('@/components/Admin/TranslationBox.vue'));
